import { useState } from 'react';
import { useStore } from '../context/ProductStore';
import { Plus, Search, Edit2, Trash2, Calendar, Clock, Tag, ExternalLink, Newspaper } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import './ProductsList.css';
import './BlogsAdmin.css';

export default function BlogsList() {
  const { blogs, deleteBlog } = useStore();
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const filteredBlogs = blogs.filter(blog => 
    blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    blog.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this blog post?')) {
      try {
        await deleteBlog(id);
      } catch (err) {
        alert('Failed to delete blog');
      }
    }
  };

  return (
    <div className="products-list-page blog-list-container">
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title" style={{ fontFamily: 'var(--font-display)' }}>
            Blog Journal
          </h1>
          <p className="admin-page-sub">Manage your nutrition articles and health tips</p>
        </div>
        <Link to="/admin/blogs/add" className="admin-btn-primary" style={{ padding: '12px 24px', borderRadius: '12px' }}>
          <Plus size={18} /> Add New Article
        </Link>
      </div>

      <div className="admin-card list-controls" style={{ borderRadius: '16px', padding: '20px' }}>
        <div className="search-bar" style={{ background: '#f8fafc', borderRadius: '12px' }}>
          <Search size={18} />
          <input 
            type="text" 
            placeholder="Search articles by title or category..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="admin-card table-container" style={{ borderRadius: '16px', overflow: 'hidden' }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th style={{ paddingLeft: '24px' }}>Article Details</th>
              <th>Category</th>
              <th>Date & Read Time</th>
              <th>Status</th>
              <th style={{ paddingRight: '24px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBlogs.map(blog => (
              <tr key={blog._id || blog.id}>
                <td style={{ paddingLeft: '24px' }}>
                  <div className="product-cell">
                    <div className="product-img-mini" style={{ borderRadius: '10px', width: '60px', height: '40px' }}>
                      <img src={blog.image} alt="" onError={(e) => e.target.src = 'https://via.placeholder.com/60/fdf8f0/7a4e2d?text=Blog'} />
                    </div>
                    <div className="product-info-mini">
                      <div className="product-name-mini" style={{ fontSize: '15px', fontWeight: 600 }}>{blog.title}</div>
                      <div className="product-slug-mini">/{blog.slug}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="badge badge-gold" style={{ borderRadius: '6px', fontWeight: 600 }}>
                    <Tag size={12} style={{ marginRight: 4 }} />
                    {blog.category}
                  </span>
                </td>
                <td>
                  <div className="blog-meta-cell">
                    <div className="meta-item"><Calendar size={12} /> {blog.date}</div>
                    <div className="meta-item"><Clock size={12} /> {blog.readTime}</div>
                  </div>
                </td>
                <td>
                  <span className={`status-badge ${blog.status === 'published' ? 'status-active' : 'status-draft'}`} style={{ borderRadius: '6px' }}>
                    {blog.status === 'published' ? 'Live' : 'Draft'}
                  </span>
                </td>
                <td style={{ paddingRight: '24px' }}>
                  <div className="action-btns">
                    <a href={`/blog/${blog.slug}`} target="_blank" rel="noreferrer" className="action-btn view" title="View Live" style={{ background: '#f1f5f9', color: '#64748b' }}>
                      <ExternalLink size={16} />
                    </a>
                    <button className="action-btn edit" onClick={() => navigate(`/admin/blogs/edit/${blog._id || blog.id}`)} title="Edit" style={{ background: '#f1f5f9', color: '#1e293b' }}>
                      <Edit2 size={16} />
                    </button>
                    <button className="action-btn delete" onClick={() => handleDelete(blog._id || blog.id)} title="Delete" style={{ background: '#fef2f2', color: '#ef4444' }}>
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {filteredBlogs.length === 0 && (
              <tr>
                <td colSpan="5" className="empty-table" style={{ padding: '80px 0', textAlign: 'center' }}>
                  <div style={{ opacity: 0.3, marginBottom: '16px' }}><Newspaper size={48} /></div>
                  <p style={{ color: '#64748b' }}>No blog posts found. Start by creating your first article!</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
